var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 96,
    viewBox: "0 0 94 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8411 80.2256L21.5351 72.3102C19.0723 71.4759 17.7576 68.7996 18.5918 66.3368C19.4261 63.8741 22.1024 62.5593 24.5585 63.3936L47.8645 71.309C50.3272 72.1433 51.642 74.8196 50.8078 77.2757C49.9735 79.7451 47.3038 81.0666 44.8411 80.2256Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7776 89.249L18.4717 81.3336C16.0089 80.4993 14.6941 77.823 15.5283 75.3669C16.3626 72.9042 19.0389 71.5893 21.5017 72.4236L44.8077 80.3324C47.2704 81.1667 48.5852 83.843 47.751 86.3058C46.91 88.7685 44.2404 90.0833 41.7776 89.249Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 39.0531C21.0879 39.1332 21.1079 39.2066 21.1346 39.2867C21.6552 40.9485 24.7253 51.4803 23.4439 63.1666L48.445 71.4158C54.3716 61.2645 63.1081 54.6371 64.5163 53.6093C64.583 53.5626 64.6498 53.5159 64.7099 53.4692C65.3906 52.982 66.0514 52.4614 66.6921 51.9074C70.4563 48.6571 73.4195 44.379 75.0881 39.32C80.0069 24.4234 71.9179 8.35886 57.0213 3.44004C42.1247 -1.47878 26.0601 6.61025 21.1413 21.5069C19.4661 26.5725 19.2992 31.7716 20.3938 36.6237C20.5807 37.438 20.8009 38.2522 21.0612 39.0531Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7464 81.8809C19.466 86.8197 22.5094 91.5249 27.4349 93.1534C32.2937 94.7552 37.4661 92.8531 40.2159 88.8286L19.7464 81.8809Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2726 65.616L38.7009 43.1043C39.4351 40.8885 38.227 38.4991 36.0112 37.765C33.7954 37.0308 31.4061 38.2389 30.6719 40.4547C29.9378 42.6705 31.1458 45.0598 33.3616 45.7939L42.2782 48.7372",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0701 68.853L48.4984 46.3412C49.2325 44.1254 51.6218 42.9241 53.8376 43.6516C56.0534 44.3857 57.2548 46.775 56.5273 48.9908C55.7932 51.2066 53.4038 52.408 51.188 51.6805L42.2714 48.7372",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3674 47.0754L87.8958 49.5648",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8181 37.5914L91.6602 36.4101",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1016 55.2111L80.6945 60.8307",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4427 23.9963L2.91431 21.5135",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3192 14.3188L7.72632 8.69924",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8354 33.6671L2 34.8484",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbWhite);
export default __webpack_public_path__ + "static/media/bulbWhite.4eac35ebf1cabffafa9525d697d9d45c.svg";
export { ForwardRef as ReactComponent };